export default __webpack_public_path__ + "static/media/s1.da770415.jpg";